import _ from "lodash";
import moment from "moment";
import submit from "submit-form";
import { useTranslation } from "react-i18next";
import DateInput from "../../../parts/inputs/date-input";
import NavigationComponent from "../calendar/components/NavigationComponent";
import { useState, useEffect } from "react";
import {
  getOutcomeValues,
  getPersonalRecordLoad,
  getRepMax,
} from "../../../utils/exercise-history";
import { PRIMARIESWITHOLYMPIC, DATE_FORMATS } from "../../../constants";
import { AthleteLinks } from "../../../parts/athlete-links";
import { AthleteSelect } from "../../../parts/inputs/athlete-select-new";
import Dropdown from "../../../parts/dropdown";
import { getUserToRequest } from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import getAvatarUrl from "../../../utils/get-avatar-url";
import { ReportsBackHandler } from "./components/ReportsBackHandler";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

const PersonalRecordTable = ({ locals }) => {
  const { t } = useTranslation("athlete-portal");
  const { query, pathname, athlete: athleteForLinks } = locals;
  const { athlete } = query;
  const organizationCoach = query.organizationCoach || undefined;
  const organizationCoachParam = organizationCoach
    ? `&organizationCoach=${organizationCoach}`
    : "";
  const athleteInfo = locals.athlete ? locals.athlete : locals.activeUser;
  const userToMeasure = getUserToRequest(
    locals.activeUser,
    locals.organizationOwner
  );

  //units by user preference
  const units = {
    units: locals.activeUser.units,
    label: locals.activeUser.units === "metric" ? "Kg" : "Lb",
    round: userToMeasure.round,
    repMaximums: athleteInfo.repMaximums,
    intensityMeasure: userToMeasure.intensityMeasure === "rpe" ? "RPE" : "RiR",
  };

  //priority to order the exercises in the select
  const priority = {
    "All Exercises": {
      "All Exercises": 1,
    },
    squat: {
      primary: 2,
      secondary: 3,
    },
    bench: {
      primary: 4,
      secondary: 5,
    },
    deadlift: {
      primary: 6,
      secondary: 7,
    },
    clean: {
      primary: 8,
      secondary: 9,
    },
    jerk: {
      primary: 10,
      secondary: 11,
    },
    snatch: {
      primary: 12,
      secondary: 13,
    },
    overheadPress: {
      primary: 14,
      secondary: 15,
    },
    other: {
      primary: 16,
      secondary: 17,
    },
    assistant: {
      assistant: 18,
    },
  };
  //first table of specific exercise
  const firstTable = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
  //array of days to can detect if we have to desplay the date in format of DD or D
  const formatedDays = ["01", "02", "03", "04", "05", "06", "07", "08", "09"];
  //array of 12 reps
  const allReps = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  //second table of specific exercise
  const secondTable = [
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
  ];
  //third table of specific exercise
  const thirdTable = [
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
  ];

  const entireTable = firstTable.concat(secondTable, thirdTable);

  // All the exercises from the api
  const exercisesData = locals.exerciseHistory
    ? locals.exerciseHistory.exercises
    : [];

  //get the sets of the exercises
  const exercisesSets = exercisesData
    .flatMap((exercise) => {
      return exercise.sets.map((set) => {
        const { load, e1rm, reps, volume, rpe } = getOutcomeValues(set);

        return Object.assign({}, set, {
          load,
          e1rm,
          reps,
          volume,
          rpe,
          utcDate: exercise.utcDate,
          repMax: getRepMax(exercise, set),
        });
      });
    });

  // personal records data
  const personalRecords = getPersonalRecordLoad(exercisesSets);

  //default option to the select
  const initMovement = {
    label: t("personalRecords.allExercises"),
    primary: "All Exercises",
    secondary: "All Exercises",
    type: "All Exercises",
    value: "All Exercises",
  };

  //start date to show in the input
  const [startDateToShow, setStartDateToShow] = useState(
    query.from
      ? moment(query.from)
      : moment().subtract(6, "months").format("MMM DD, YYYY")
  );

  //end state to show in the input
  const [endDateToShow, setEndDateToShow] = useState(
    query.to ? moment(query.to) : moment()
  );

  //start date to filter the exercises
  const [startDateToFilter, setStartDateToFilter] = useState(
    moment.utc(moment().subtract(6, "months"))
  );

  //end state to filter the exercises
  const [endDateToFilter, setEndDateToFilter] = useState(moment.utc(moment()));

  //control the date range tab state (1 month, 3 months... lifetime...)
  const [tabState, setTabState] = useState(
    query.activeRange ? query.activeRange : "six-months-tab"
  );

  //selected option
  const [currentMovement, setCurrentMovement] = useState(
    query.movementSelected ? JSON.parse(query.movementSelected) : initMovement
  );

  //-------------init get info for the select-------------------
  //all data
  const exercisesRecordsLoad = locals.exercisesRecordsLoadWithAssistants
    ? locals.exercisesRecordsLoadWithAssistants
    : [];
  //array to store the final exercises for the select
  const exercisesToSelecInput = [initMovement];
  //constants to have the specific data from each primary exercises
  const assistantObject = exercisesRecordsLoad.assistant;
  const benchObject = exercisesRecordsLoad.bench;
  const squatObject = exercisesRecordsLoad.squat;
  const deadliftObject = exercisesRecordsLoad.deadlift;
  const cleanObject = exercisesRecordsLoad.clean;
  const jerkObject = exercisesRecordsLoad.jerk;
  const snatchObject = exercisesRecordsLoad.snatch;
  const overheadPressObject = exercisesRecordsLoad.overheadPress;
  const otherObject = exercisesRecordsLoad.other;

  if (assistantObject) {
    findExercisesToSelectInput(assistantObject);
  }
  if (benchObject) {
    findExercisesToSelectInput(benchObject);
  }
  if (squatObject) {
    findExercisesToSelectInput(squatObject);
  }
  if (deadliftObject) {
    findExercisesToSelectInput(deadliftObject);
  }
  if (cleanObject) {
    findExercisesToSelectInput(cleanObject);
  }
  if (jerkObject) {
    findExercisesToSelectInput(jerkObject);
  }
  if (snatchObject) {
    findExercisesToSelectInput(snatchObject);
  }
  if (overheadPressObject) {
    findExercisesToSelectInput(overheadPressObject);
  }
  if (otherObject) {
    findExercisesToSelectInput(otherObject);
  }

  //delete repeated movements for the select and order them
  const movementSelect = [...new Set(exercisesToSelecInput.map(JSON.stringify))]
    .map(JSON.parse)
    .sort((firstExcercise, secondExercise) => {
      const firstPriority = priority[firstExcercise.primary][
        firstExcercise.type
      ]
        ? priority[firstExcercise.primary][firstExcercise.type]
        : 9;
      const secondPriority = priority[secondExercise.primary][
        secondExercise.type
      ]
        ? priority[secondExercise.primary][secondExercise.type]
        : 9;

      return firstPriority - secondPriority;
    });

  /**
   * function to push the exercises to the array who store the exercises for the select input
   * @param {*} data
   */
  function findExercisesToSelectInput(data) {
    Object.keys(data).forEach((exerciseKey) => {
      allReps.forEach((index) => {
        if (data[exerciseKey][index]) {
          const item = formatExerciseValues(data[exerciseKey][index]);
          exercisesToSelecInput.push(item);
        }
      });
    });
  }

  /**
   * Function to return the necessary values to the select option
   * @returns
   */
  function formatExerciseValues(data) {
    const formattedMovement =
      data.primary.charAt(0).toUpperCase() + data.primary.slice(1);

    return {
      label:
        data.primary === "assistant"
          ? data.secondary
          : !data.secondary || data.secondary === null
          ? formattedMovement
          : data.secondary + ` (${formattedMovement})`,
      value:
        !data.secondary || data.secondary === null
          ? data.primary
          : `${data.primary}${data.secondary}`,
      primary: data.primary,
      type: data.type,
      secondary: data.secondary ? data.secondary : null,
      parameters: data.parameters ? data.parameters : null,
    };
  }

  /**
   * show all exercises
   */
  const showAll = () => {
    setCurrentMovement(initMovement);
  };

  //-------------start filter data -------
  const arrayToStoreFilteredData = [];
  const [exercisesNames, setExercisesNames] = useState([]);
  useEffect(() => {
    if (squatObject) {
      filteredDataToshow(squatObject);
    }
    if (benchObject) {
      filteredDataToshow(benchObject);
    }
    if (deadliftObject) {
      filteredDataToshow(deadliftObject);
    }
    if (cleanObject) {
      filteredDataToshow(cleanObject);
    }
    if (jerkObject) {
      filteredDataToshow(jerkObject);
    }
    if (snatchObject) {
      filteredDataToshow(snatchObject);
    }
    if (overheadPressObject) {
      filteredDataToshow(overheadPressObject);
    }
    if (otherObject) {
      filteredDataToshow(otherObject);
    }
    if (assistantObject) {
      filteredDataToshow(assistantObject);
    }
    setExercisesNames(arrayToStoreFilteredData);
  }, [startDateToFilter, endDateToFilter]);

  function filteredDataToshow(object) {
    Object.keys(object).forEach((exerciseKey) => {
      allReps.forEach((index) => {
        if (object[exerciseKey][index]) {
          if (
            object[exerciseKey][index].date &&
            moment.utc(object[exerciseKey][index].date) >= startDateToFilter &&
            moment.utc(object[exerciseKey][index].date) <= endDateToFilter
          ) {
            const name =
              object[exerciseKey][index].secondary &&
              object[exerciseKey][index].secondary.length > 0
                ? object[exerciseKey][index].secondary
                : object[exerciseKey][index].primary;

            arrayToStoreFilteredData.push(name);
          }
        }
      });
    });
  }

  //--------------end filter data-------

  /**
   * Change the selected exercise
   * @param {*} value
   */
  const handleMovementSelect = (value) => {
    const { secondary, type, primary } = value;

    const startFormat = startDateToFilter.format("YYYY-MM-DD");
    const endFormat = endDateToFilter.format("YYYY-MM-DD");

    const startDateSend = `${startFormat}T04:00:00Z`;
    const endDateSend = `${endFormat}T04:00:00Z`;

    setCurrentMovement(value);
    if (!secondary || secondary === null) {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          primary,
          type,
          secondary: "",
          from: startDateSend,
          to: endDateSend,
          movementSelected: JSON.stringify(value),
        },
      });
    } else {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          primary,
          type,
          secondary,
          from: startDateSend,
          to: endDateSend,
          movementSelected: JSON.stringify(value),
        },
      });
    }
  };

  /**
   * Change start date
   * @param {*} e
   */
  const handleStartDateInput = (e) => {
    if (startDateToShow !== moment(e).format("MMM DD, YYYY")) {
      const format = moment(e).format("YYYY-MM-DD");
      const dateSend = `${format}T04:00:00Z`;
      setStartDateToShow(moment(e).format("MMM DD, YYYY"));
      setStartDateToFilter(moment.utc(moment(e)));
      setTabState("");
      if (currentMovement.value !== "All Exercises") {
        submit(`/actions/refresh/?`, {
          method: "GET",
          body: {
            from: dateSend,
            activeRange: "",
          },
        });
      }
    }
  };
  /**
   * Change end date
   * @param {*} e
   */
  const handleEndDateInput = (e) => {
    if (endDateToShow !== moment(e).format("MMM DD, YYYY")) {
      const format = moment(e).format("YYYY-MM-DD");
      const dateSend = `${format}T04:00:00Z`;
      setEndDateToShow(moment(e).format("MMM DD, YYYY"));
      setEndDateToFilter(moment.utc(moment(e)));
      setTabState("");
      if (currentMovement.value !== "All Exercises") {
        submit(`/actions/refresh/?`, {
          method: "GET",
          body: {
            to: dateSend,
            activeRange: "",
          },
        });
      }
    }
  };

  /**
   * Change the date range
   * @param {*} tab
   */
  const handleActiveTab = (tab) => {
    setTabState(tab);
    setDateRange(tab);
  };

  /**
   * Request the exercises with the selected date range
   * @param {*} tab
   */
  const setDateRange = (tab) => {
    const today = moment();
    const lifetimeDate = "2015-12-31T07:57:45.121Z"; //date when MSB starts
    const periodDate =
      tab === "two-weeks-tab"
        ? moment().subtract(14, "days")
        : tab === "one-months-tab"
        ? moment().subtract(1, "months")
        : tab === "three-months-tab"
        ? moment().subtract(3, "months")
        : tab === "six-months-tab"
        ? moment().subtract(6, "months")
        : moment(lifetimeDate);
    const startFormat = periodDate.format("YYYY-MM-DD");
    const endFormat = today.format("YYYY-MM-DD");
    const startDateSend = `${startFormat}T04:00:00Z`;
    const endDateSend = `${endFormat}T04:00:00Z`;
    setStartDateToShow(periodDate.format("MMM DD, YYYY"));
    setEndDateToShow(today.format("MMM DD, YYYY"));
    setStartDateToFilter(moment.utc(periodDate));
    setEndDateToFilter(moment.utc(today));
    if (currentMovement.value !== "All Exercises") {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          from: startDateSend,
          to: endDateSend,
          activeRange: tab,
        },
      });
    }
  };

  /**
   * Format date and load
   * @param {*} rep
   * @returns
   */
  const formatDayAndLoad = (rep) => {
    const load =
      personalRecords && personalRecords[rep]
        ? personalRecords[rep].load
        : undefined;
    const formattedLoad = load
      ? `${_.round(locals.fromMetric(load, units.units, false), 1)}${
          units.label
        }`
      : "-";
    const date =
      personalRecords && personalRecords[rep]
        ? personalRecords[rep].utcDate
        : undefined;
    const formattedDate =
      date && load
        ? formatedDays.includes(moment(date, "YYYYMMDD").format("DD"))
          ? moment(date, "YYYYMMDD").format("MMM D, YYYY")
          : moment(date, "YYYYMMDD").format("MMM DD, YYYY")
        : "-";

    return { formattedLoad, formattedDate };
  };

  /**
   * Redirect to calendar day view
   * @param {*} date
   */
  const redirectToCalendarView = (date) => {
    const athleteUrl = `/${
      athlete
        ? `athlete-portal/calendar/?athlete=${athlete}&`
        : "dashboard/calendar/?"
    }view=day&date=${date}`;
    const url = athleteUrl + organizationCoachParam;

    window.location.href = url;
  };
  const rows = _.flatMap(
    [...PRIMARIESWITHOLYMPIC, "assistant", "other"],
    (primary) => {
      const secondaries = exercisesRecordsLoad[primary];
      return _(secondaries)
        .map((reps, secondary) => {
          return { reps, secondary };
        })
        .sortBy("secondary")
        .map(({ reps, secondary }) => {
          const secondaryLabel = secondary
            ? primary === "assistant"
              ? secondary
              : `(${secondary})`
            : "";

          const nameToCompare =
            secondary && secondary.length > 0 ? secondary : primary;
          if (exercisesNames.includes(nameToCompare)) {
            return (
              <tr key={primary + secondary}>
                <td>
                  {primary !== "assistant"
                    ? `${_.capitalize(primary)} ${secondaryLabel}`
                    : `${secondaryLabel}`}
                </td>
                {_.map(_.range(1, 13), (i) => {
                  const load = _.get(reps[i], "load");
                  const date = moment.utc(_.get(reps[i], "date"));

                  if (
                    !_.get(reps[i], "date") ||
                    date < startDateToFilter ||
                    date > endDateToFilter
                  ) {
                    return <td key={i} />;
                  }
                  if (!load) return <td key={i} />;
                  return (
                    <td key={i}>
                      <a
                        href={`/${
                          athlete
                            ? `athlete-portal/calendar/?athlete=${athlete}&`
                            : "dashboard/calendar/?"
                        }view=day&date=${date.format(DATE_DAY_FORMAT)}`}
                        className="metrics-table-link"
                        style={{ textDecoration: "none" }}
                      >
                        {_.round(
                          locals.fromMetric(load, units.units, false),
                          1
                        )}{" "}
                        {units.label}
                      </a>
                    </td>
                  );
                })}
              </tr>
            );
          }
        })
        .value();
    }
  );
  const rowsToDisplay = rows.filter((row) => row !== undefined);
  return (
    <main role="reports-wrapper">
      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athleteForLinks}
          pathName={pathname}
          classNames={"only-show-mobile"}
          query={query}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(athlete?._id)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>
      <NavigationComponent
        query={query}
        textKey="nav.calendarDayView"
        pathName={locals.pathname}
        classNames="mobile-hidden"
      />

      <article role="report-content" id="personal-records">
        <header>
          <hgroup>
            <h2 className="mobile-hidden">{t("personalRecords.title")}</h2>
            <ReportsBackHandler title={t("personalRecords.title")} locals={locals} />
          </hgroup>
          <hgroup>
            <div role="calendar-date-selectors" className="mobile-hidden">
              <DateInput
                name="start"
                placeholder={t("reports.startDate")}
                value={startDateToShow}
                onChange={(e) => handleStartDateInput(e)}
              />
              <span>{t("reports.to")}</span>
              <DateInput
                name="end"
                placeholder={t("reports.endDate")}
                value={endDateToShow}
                onChange={(e) => handleEndDateInput(e)}
              />
            </div>
            <div className="selector-container" id="tabsSection">
              <button
                data-button-type={
                  tabState === "two-weeks-tab" ? "primary" : "secondary"
                }
                onClick={() => handleActiveTab("two-weeks-tab")}
              >
                {t("reports.rangeSelector.twoWeeks")}
              </button>
              <button
                data-button-type={
                  tabState === "one-months-tab" ? "primary" : "secondary"
                }
                onClick={() => handleActiveTab("one-months-tab")}
              >
                {t("reports.rangeSelector.oneMonth")}
              </button>
              <button
                data-button-type={
                  tabState === "three-months-tab" ? "primary" : "secondary"
                }
                onClick={() => handleActiveTab("three-months-tab")}
              >
                {t("reports.rangeSelector.threeMonths")}
              </button>
              <button
                data-button-type={
                  tabState === "six-months-tab" ? "primary" : "secondary"
                }
                onClick={() => handleActiveTab("six-months-tab")}
              >
                {t("reports.rangeSelector.sixMonths")}
              </button>
              <button
                data-button-type={
                  tabState === "lifetime-tab" ? "primary" : "secondary"
                }
                onClick={() => handleActiveTab("lifetime-tab")}
              >
                {t("reports.rangeSelector.lifetime")}
              </button>
            </div>
          </hgroup>
        </header>
        <section>
          <Dropdown
            summaryText={currentMovement.label}
            options={movementSelect}
            onSelectFn={(value) => {
              handleMovementSelect(
                movementSelect.find((op) => op.value === value)
              );
            }}
          />
          {currentMovement.value !== "All Exercises" && (
            <a className="mobile-hidden" onClick={showAll}>
              {t("personalRecords.showAllExercises")}
            </a>
          )}
        </section>
        {currentMovement.value === "All Exercises" ? (
          <section role="table-wrapper">
            <table role="report-table">
              <thead>
                <tr>
                  <th>
                    <span>{t("personalRecords.exercise")}</span>
                    {/* <span className="right">Reps:</span> */}
                  </th>
                  <th>{t("personalRecords.oneRep")}</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                  <th>6</th>
                  <th>7</th>
                  <th>8</th>
                  <th>9</th>
                  <th>10</th>
                  <th>11</th>
                  <th>12</th>
                </tr>
              </thead>
              <tbody>
                {rowsToDisplay.length > 0 && rows.map((row) => row)}
                {rowsToDisplay.length === 0 && (
                  <tr>
                    <td colSpan="13">
                      <div className="flex items-center justify-center gap-2 py-40">
                        <p className="s1">
                          {t("personalRecords.noRecords")}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </section>
        ) : (
          <>
            <div className="flex gap-2 only-show-mobile">
              <section role="table-wrapper">
                <table role="report-table">
                  <tbody>
                    <tr>
                      <th>{t("personalRecords.reps")}</th>
                      <th>{t("reports.date")}</th>
                      <th>{t("personalRecords.load")}</th>
                    </tr>

                    {entireTable.map((rep) => {
                      const { formattedDate, formattedLoad } =
                        formatDayAndLoad(rep);

                      return formattedLoad === "-" ? (
                        <tr>
                          <td>{rep}</td>
                          <td>{formattedDate}</td>
                          <td>{formattedLoad}</td>
                        </tr>
                      ) : (
                        <tr
                          onClick={() =>
                            redirectToCalendarView(personalRecords[rep].utcDate)
                          }
                          className="cursor-pointer"
                        >
                          <td>{rep}</td>
                          <td>{formattedDate}</td>
                          <td>{formattedLoad}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </section>
            </div>
            <div className="flex gap-2 mobile-hidden">
              <section role="table-wrapper">
                <table role="report-table">
                  <tbody>
                    <tr>
                      <th>{t("personalRecords.reps")}</th>
                      <th>{t("reports.date")}</th>
                      <th>{t("personalRecords.load")}</th>
                    </tr>

                    {firstTable.map((rep) => {
                      const { formattedDate, formattedLoad } =
                        formatDayAndLoad(rep);

                      return formattedLoad === "-" ? (
                        <tr>
                          <td>{rep}</td>
                          <td>{formattedDate}</td>
                          <td>{formattedLoad}</td>
                        </tr>
                      ) : (
                        <tr
                          onClick={() =>
                            redirectToCalendarView(personalRecords[rep].utcDate)
                          }
                          className="cursor-pointer"
                        >
                          <td>{rep}</td>
                          <td>{formattedDate}</td>
                          <td>{formattedLoad}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </section>
              <section role="table-wrapper">
                <table role="report-table">
                  <tbody>
                    <tr>
                      <th>{t("personalRecords.reps")}</th>
                      <th>{t("reports.date")}</th>
                      <th>{t("personalRecords.load")}</th>
                    </tr>
                    {secondTable.map((rep) => {
                      const { formattedDate, formattedLoad } =
                        formatDayAndLoad(rep);
                      return formattedLoad === "-" ? (
                        <tr>
                          <td>{rep}</td>
                          <td>{formattedDate}</td>
                          <td>{formattedLoad}</td>
                        </tr>
                      ) : (
                        <tr
                          onClick={() =>
                            redirectToCalendarView(personalRecords[rep].utcDate)
                          }
                          className="cursor-pointer"
                        >
                          <td>{rep}</td>
                          <td>{formattedDate}</td>
                          <td>{formattedLoad}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </section>
              <section role="table-wrapper">
                <table role="report-table">
                  <tbody>
                    <tr>
                      <th>{t("personalRecords.reps")}</th>
                      <th>{t("reports.date")}</th>
                      <th>{t("personalRecords.load")}</th>
                    </tr>
                    {thirdTable.map((rep) => {
                      const { formattedDate, formattedLoad } =
                        formatDayAndLoad(rep);

                      return formattedLoad === "-" ? (
                        <tr>
                          <td>{rep}</td>
                          <td>{formattedDate}</td>
                          <td>{formattedLoad}</td>
                        </tr>
                      ) : (
                        <tr
                          onClick={() =>
                            redirectToCalendarView(personalRecords[rep].utcDate)
                          }
                          className="cursor-pointer"
                        >
                          <td>{rep}</td>
                          <td>{formattedDate}</td>
                          <td>{formattedLoad}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </section>
            </div>
          </>
        )}
      </article>
    </main>
  );
};

export default PersonalRecordTable;
